import PageHero from "../components/PageHero";
import SmartLink from "../components/SmartLink";
import { blogPage } from "../lib/content";

export default function BlogPage() {
  return (
    <>
      <PageHero eyebrow={blogPage.eyebrow} title={blogPage.title} intro={blogPage.intro} />

      <section className="section-pad bg-white">
        <div className="container-page">
          <div className="card mx-auto max-w-2xl border-dashed p-12 text-center">
            <p className="text-base font-medium text-ink-muted">{blogPage.emptyState}</p>
            <SmartLink href={blogPage.notifyCta.href} className="btn-primary mt-6">
              {blogPage.notifyCta.label}
            </SmartLink>
          </div>
        </div>
      </section>
    </>
  );
}
